<ng-container *ngIf="loading"> 
  <div class="container-with-loading">
      <div class="loading-overlay">
          <mat-spinner></mat-spinner>
      </div>
  </div>
</ng-container>
<div class="login-wrapper">
  <mat-card class="card-body" appearance="outlined" [hidden]="loading">
    <mat-card-header class='headerCard'>
      <mat-card-title>
        <mat-icon>account_circle</mat-icon>Iniciar Sesi&oacute;n
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="contendCard">
      <div class="contend">
        <form>
          <div class="mb-3">
            <mat-form-field class="controlHeight">
              <mat-label>Correo electr&oacute;nico</mat-label>
              <input id="email" type="email" matInput [formControl]="emailFormControl"
              placeholder="ejemplo@correo.com" [(ngModel)]="user.email" required/>
            </mat-form-field>
          </div>
          <div class="mb-3">
            <mat-form-field class="controlHeight">
              <mat-label>Contrase&ntilde;a</mat-label>
              <input id="password" type="password" matInput [formControl]="passFormControl"
              placeholder="Ingresa tu contrase&ntilde;a" [(ngModel)]="user.password" required/>
            </mat-form-field>
          </div>
        </form>
      </div>
      <div class="mb-3">
        <label>
          <a routerLink="/reset-password" class="text-decoration-none">
            ¿Olvidaste tu contrase&ntilde;a?
          </a>
        </label>
      </div>
    </mat-card-content>
    <mat-card-actions class="contendCard">
      <div >
        <button mat-flat-button class="button controlHeight" (click) ='onSubmit()'><mat-icon>login</mat-icon>Entrar</button>
      </div>
    </mat-card-actions>
  </mat-card>
</div>